[
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "15h45min",
    "numero": 19,
    "titulo": "Literacia parental sobre anquiloglossia e implicações no desenvolvimento infantil – state of art",
    "autor": "Beatriz Martins"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "15h52min",
    "numero": 20,
    "titulo": "Os primeiros 1000 dias e a saúde oral: Um período decisivo para a prevenção",
    "autor": "Beatriz Carneiro"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "15h59min",
    "numero": 21,
    "titulo": "Suplementos coadjuvantes do sono em idade pediátrica e saúde oral: revisão narrativa da literatura",
    "autor": "Anita Rodrigues"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "16h06min",
    "numero": 22,
    "titulo": "Leite de fórmula e implicações na saúde oral do bebé: revisão narrativa da literatura",
    "autor": "Emilia Pereira"
  },
  {
    "dia": "14T",
    "mupi": 3,
    "hora": "16h12min",
    "numero": 35,
    "titulo": "A importância da Terapia da Fala associada à Ortodontia",
    "autor": "Mariana Pascoal"
  }
]